var watcher = {};

watcher.init = function() {

  watcher.isInThread = document.getElementById('threadIdentifier') ? true
      : false;
  watcher.watcherAlertCounter = 0;
  watcher.elementRelation = {};

  // The nav button is STATIC markup (leftBar.njk, after #linkOverboard) since
  // 2026-08-30: it used to be created + inserted HERE after first paint, shifting
  // the boards list ~35px on every load. Wire the existing element; the create
  // + insert path stays only as a fallback for a page without leftBar.
  var watcherButton = document.getElementById('watcherButton');
  if (!watcherButton) {
    watcherButton = document.createElement('a');
    watcherButton.id = 'watcherButton';
    var navAnchor = document.getElementById('linkOverboard')
        || document.getElementById('navStart');
    if (navAnchor) {
      navAnchor.parentNode.insertBefore(watcherButton,
          navAnchor.nextSibling);
    }
  }

  // Counter: reuse the static <span>0</span>; create one only if absent, so
  // updateWatcherCounter() (called unconditionally below) always has an
  // element to write to.
  watcher.watcherCounter = watcherButton.querySelector('span')
      || watcherButton.appendChild(document.createElement('span'));

  watcher.watchedMenu = document.createElement('div');

  var watchedMenuLabel = document.createElement('label');
  watchedMenuLabel.className = 'watchedMenuTitle';
  watchedMenuLabel.innerHTML = 'Watched threads';

  watcher.watchedMenu.appendChild(watchedMenuLabel);

  var showingWatched = false;

  // External close (mutual exclusion, operator 2026-08-30): navBurger.js /
  // settingsMenu.js dispatch 'watcher-close' when THEY open, so our internal
  // state stays in sync — closing via display:none alone would leave
  // showingWatched true and swallow the next eye tap.
  watcher.close = function() {
    if (!showingWatched) return;
    showingWatched = false;
    watcher.watchedMenu.style.display = 'none';
  };
  document.addEventListener('watcher-close', watcher.close);

  var closeWatcherMenuButton = document.createElement('span');
  closeWatcherMenuButton.id = 'closeWatcherMenuButton';
  closeWatcherMenuButton.onclick = function() {

    if (!showingWatched) {
      return;
    }

    showingWatched = false;
    watcher.watchedMenu.style.display = 'none';

  };

  watcher.watchedMenu.appendChild(closeWatcherMenuButton);

  watcher.watchedMenu.appendChild(document.createElement('hr'));

  // Scrollable list container: thread rows live here (not directly in the
  // menu) so _watcher.scss can cap it at 7 visible rows + overflow-y:auto.
  // The title bar and close X stay pinned above it, keeping the popup a
  // consistent size no matter how many threads are watched (operator
  // 2026-08-19).
  watcher.watchedList = document.createElement('div');
  watcher.watchedList.id = 'watchedList';
  watcher.watchedMenu.appendChild(watcher.watchedList);

  watcher.watchedMenu.id = 'watchedMenu';
  watcher.watchedMenu.className = 'floatingMenu';
  watcher.watchedMenu.style.display = 'none';

  document.body.appendChild(watcher.watchedMenu);

  // Toggle the watched-threads menu, anchored near where the user clicked
  // (the original used a fixed top-left spot far from the cursor), clamped so
  // it stays on-screen.
  watcherButton.onclick = function(event) {

    showingWatched = !showingWatched;

    if (showingWatched) {
      if (window.matchMedia('(max-width: 767px)').matches) {
        // Mobile: full-screen sheet below the top icon row (see _watcher.scss
        // mobile block + .staffNavPanel idiom). #topNav's height is measured,
        // not hardcoded, so the row stays visible and the eye doubles as the
        // close toggle. Cursor-anchoring is skipped — on touch it rendered
        // partially off-screen (offsetWidth reads 0 while display:none, so the
        // clamp fell back to a stale 260px guess).
        //
        // Mutual exclusion FIRST (operator 2026-08-30: only one of boards-burger /
        // watched-list / settings may be open): with the burger open its board
        // panel inflates #topNav's in-flow height, so measuring AFTER closing
        // it is what keeps the sheet anchored under the icon row instead of at
        // the bottom of the screen.
        document.querySelectorAll('#topNav.open, #bottomNav.open').forEach(function (n) {
          n.classList.remove('open');
        });
        if (window.settingsMenu && settingsMenu.close) { settingsMenu.close(); }
        document.dispatchEvent(new CustomEvent('staffnav-close'));
        var topNav = document.getElementById('topNav');
        watcher.watchedMenu.style.left = '0px';
        watcher.watchedMenu.style.right = '0px';
        // no bottom: content-sized card (2026-08-30 consistency with the burger
        // panel) — the CSS mobile block owns bottom:auto + the 7-row cap
        watcher.watchedMenu.style.top = (topNav ? topNav.offsetHeight : 0) + 'px';
      } else {
        // clear any inline sheet insets left over from a mobile open (resize/
        // rotation) — with position:fixed, stale right/bottom would stretch
        // the card against the anchored left/top
        watcher.watchedMenu.style.right = 'auto';
        watcher.watchedMenu.style.bottom = 'auto';
        var menuW = watcher.watchedMenu.offsetWidth || 260;
        var menuH = watcher.watchedMenu.offsetHeight || 120;
        var x = event.clientX;
        var y = event.clientY + 6;
        if (x + menuW > window.innerWidth) {
          x = Math.max(8, window.innerWidth - menuW - 8);
        }
        if (y + menuH > window.innerHeight) {
          y = Math.max(8, window.innerHeight - menuH - 8);
        }
        watcher.watchedMenu.style.left = x + 'px';
        watcher.watchedMenu.style.top = y + 'px';
      }
    }

    watcher.watchedMenu.style.display = showingWatched ? 'block' : 'none';

  };

  // Dismiss on outside click (same idiom as postingMenu.js / hiding.js): a
  // capture-phase body listener closes the menu unless the click landed on the
  // nav button or inside the menu itself.
  document.body.addEventListener('click', function clicked(event) {

    if (!showingWatched) {
      return;
    }
    if (watcherButton.contains(event.target)
        || watcher.watchedMenu.contains(event.target)) {
      return;
    }
    showingWatched = false;
    watcher.watchedMenu.style.display = 'none';

  }, true);

  var ops = document.getElementsByClassName('innerOP');

  for (var i = 0; i < ops.length; i++) {
    watcher.processOP(ops[i]);
  }

  var storedWatchedData = watcher.getStoredWatchedData();

  for ( var currentBoard in storedWatchedData) {

    if (storedWatchedData.hasOwnProperty(currentBoard)) {

      var threads = storedWatchedData[currentBoard];

      for ( var thread in threads) {
        if (threads.hasOwnProperty(thread)) {

          if (watcher.isInThread && currentBoard == api.boardUri
              && thread == api.threadId) {
            threads[thread].lastSeen = new Date().getTime();
            localStorage.watchedData = JSON.stringify(storedWatchedData);
          }

          watcher.addWatchedCell(currentBoard, thread, threads[thread]);
        }
      }
    }

  }

  watcher.updateWatcherCounter();

  watcher.scheduleWatchedThreadsCheck();

  draggable.setDraggable(watcher.watchedMenu, watchedMenuLabel);

};

watcher.updateWatcherCounter = function() {

  // Resolve the nav button by id: it is a local of init(), not reachable from
  // here (the original referenced the local directly, which throws ReferenceError).
  var btn = document.getElementById('watcherButton');
  if (btn) {
    var classList = btn.classList;
    if (watcher.watcherAlertCounter) {
      classList.add('mobileAlert');
    } else {
      classList.remove('mobileAlert');
    }
  }

  if (watcher.watcherCounter) {
    // Always show the number (0 included) so the nav control stays visible and
    // clickable; it is the count of unseen posts across watched threads.
    watcher.watcherCounter.innerHTML = String(watcher.watcherAlertCounter || 0);
  }
};

// Brief fading glow on the nav counter as feedback for watching a thread.
watcher.flashNavButton = function() {

  var btn = document.getElementById('watcherButton');
  if (!btn || !btn.classList) {
    return;
  }
  // Re-trigger even on rapid successive clicks by removing + forcing reflow.
  btn.classList.remove('watchGlow');
  void btn.offsetWidth;
  btn.classList.add('watchGlow');

};

watcher.getStoredWatchedData = function() {

  var storedWatchedData = localStorage.watchedData;

  if (storedWatchedData) {
    storedWatchedData = JSON.parse(storedWatchedData);
  } else {
    storedWatchedData = {};
  }

  return storedWatchedData;

};

watcher.processThread = function(urls, index, data) {

  data = JSON.parse(data);
  var url = urls[index];

  var posts = data.posts;

  if (posts && posts.length) {

    var lastPost = posts[posts.length - 1];

    var parsedCreation = new Date(lastPost.creation);

    var storedWatchedData = watcher.getStoredWatchedData();

    var watchData = storedWatchedData[url.board][url.thread];

    if (parsedCreation.getTime() > watchData.lastReplied) {
      watchData.lastReplied = parsedCreation.getTime();
      localStorage.watchedData = JSON.stringify(storedWatchedData);
    }

    if (!watcher.elementRelation[url.board]
        || !watcher.elementRelation[url.board][url.thread]) {
      watcher.addWatchedCell(url.board, url.thread, watchData);
    } else if (watchData.lastSeen >= watchData.lastReplied) {
      watcher.elementRelation[url.board][url.thread].style.display = 'none';
    } else {
      watcher.watcherAlertCounter++;
      watcher.elementRelation[url.board][url.thread].style.display = 'inline';
    }

  }

  watcher.iterateWatchedThreads(urls, ++index);

};

watcher.iterateWatchedThreads = function(urls, index) {

  index = index || 0;

  if (index >= urls.length) {
    watcher.updateWatcherCounter();
    watcher.scheduleWatchedThreadsCheck();
    return;
  }

  var url = urls[index];

  api.localRequest('/' + url.board + '/res/' + url.thread + '.json',
      function gotThreadInfo(error, data) {

        if (error) {
          watcher.iterateWatchedThreads(urls, ++index);
        } else {
          watcher.processThread(urls, index, data);
        }

      });

};

watcher.runWatchedThreadsCheck = function() {

  watcher.watcherAlertCounter = 0;

  localStorage.lastWatchCheck = new Date().getTime();

  var urls = [];

  var storedWatchedData = watcher.getStoredWatchedData();

  for ( var board in storedWatchedData) {

    if (storedWatchedData.hasOwnProperty(board)) {

      var threads = storedWatchedData[board];

      for ( var thread in threads) {
        if (threads.hasOwnProperty(thread)) {

          if (watcher.isInThread && board == api.boardUri
              && thread == api.threadId) {
            threads[thread].lastSeen = new Date().getTime();
            localStorage.watchedData = JSON.stringify(storedWatchedData);
          }

          urls.push({
            board : board,
            thread : thread
          });
        }
      }
    }

  }

  watcher.iterateWatchedThreads(urls);

};

watcher.scheduleWatchedThreadsCheck = function() {

  var lastCheck = localStorage.lastWatchCheck;

  if (!lastCheck) {
    watcher.runWatchedThreadsCheck();
    return;
  }

  lastCheck = new Date(+lastCheck);

  // lastCheck.setUTCMinutes(lastCheck.getUTCMinutes() + 5);
  lastCheck.setUTCSeconds(lastCheck.getUTCSeconds() + 10);

  setTimeout(function() {
    watcher.runWatchedThreadsCheck();
  }, lastCheck.getTime() - new Date().getTime());

}

watcher.addWatchedCell = function(board, thread, watchData) {

  var cellWrapper = document.createElement('div');

  var cell = document.createElement('div');
  cell.className = 'watchedCell';

  var labelWrapper = document.createElement('label');
  labelWrapper.className = 'watchedCellLabel';

  var label = document.createElement('a');

  label.innerHTML = watchData.label || (board + '/' + thread);
  label.href = '/' + board + '/res/' + thread + '.html';
  labelWrapper.appendChild(label);

  var notification = document.createElement('span');
  notification.className = 'watchedNotification';

  if (!watcher.elementRelation[board]) {
    watcher.elementRelation[board] = {};
  }

  watcher.elementRelation[board][thread] = notification;

  if (watchData.lastSeen >= watchData.lastReplied) {
    notification.style.display = 'none';
  } else {
    watcher.watcherAlertCounter++;
  }

  // Notification icon is its OWN flex item (not inside the label): the label
  // carries overflow:hidden + text-overflow:ellipsis, so an inline icon after
  // a long title was clipped with the overflow and never rendered.
  cell.appendChild(labelWrapper);
  cell.appendChild(notification);

  var button = document.createElement('span');
  button.className = 'watchedCellCloseButton';
  cell.appendChild(button);

  button.onclick = function() {

    watcher.watchedList.removeChild(cellWrapper);

    var storedWatchedData = watcher.getStoredWatchedData();

    var boardThreads = storedWatchedData[board];

    if (!boardThreads || !boardThreads[thread]) {
      return;
    }

    delete boardThreads[thread];

    localStorage.watchedData = JSON.stringify(storedWatchedData);

  }

  cellWrapper.appendChild(cell);
  cellWrapper.appendChild(document.createElement('hr'));
  watcher.watchedList.appendChild(cellWrapper);

};

watcher.processOP = function(op) {

  var checkBox = op.getElementsByClassName('deletionCheckBox')[0];
  if (!checkBox) {
    return;
  }

  // posting.js names the checkbox "boardUri-threadId", but a server-rendered OP
  // may not carry it — fall back to api.* (set by thread.js), then the URL, so
  // we never store a garbage board/thread key.
  var board = null,
      thread = null;
  var nameParts = (checkBox.name || '').split('-');
  if (nameParts.length >= 2 && nameParts[0] && nameParts[1]) {
    board = nameParts[0];
    thread = nameParts[1];
  } else if (api.boardUri && api.threadId) {
    board = api.boardUri;
    thread = api.threadId;
  } else {
    var locMatch = window.location.pathname.match(/\/([^/]+)\/res\/(\d+)/);
    if (locMatch) {
      board = locMatch[1];
      thread = locMatch[2];
    }
  }
  if (!board || !thread) {
    return;
  }

  var watchButton = document.createElement('span');
  watchButton.className = 'watchButton';
  watchButton.title = "Watch Thread";

  /* two-row status line: the button must join ROW 1 (.statusLineTop) before the
     .nsIdentity subject+name slot — its direct parent, so insertBefore anchors
     correctly. (Anchoring against .opHead appended it at the END of the head:
     orphan line below row 2 on mobile, end-of-line on desktop.) */
  var watchRow = checkBox.closest('.statusLineTop');
  watchRow.insertBefore(watchButton, watchRow.querySelector('.nsIdentity'));

  watchButton.onclick = function() {

    var storedWatchedData = watcher.getStoredWatchedData();

    var boardThreads = storedWatchedData[board] || {};

    if (boardThreads[thread]) {
      return;
    }

    var subject = op.getElementsByClassName('labelSubject');
    var message = op.getElementsByClassName('divMessage')[0];

    var label = (subject.length ? subject[0].innerHTML : null)
        || message.innerHTML.replace(/(<([^>]+)>)/ig, "").substr(0, 16).trim();

    if (!label.length) {
      label = null;
    } else {
      label = label.replace(/[<>"']/g, function(match) {
        return api.htmlReplaceTable[match]
      });
    }

    boardThreads[thread] = {
      lastSeen : new Date().getTime(),
      lastReplied : new Date().getTime(),
      label : label
    };

    storedWatchedData[board] = boardThreads;

    localStorage.watchedData = JSON.stringify(storedWatchedData);

    watcher.addWatchedCell(board, thread, boardThreads[thread]);

    // Feedback in the navbar: a light glow that fades.
    watcher.flashNavButton();

  };

};

watcher.init();
